import Auth from 'src/api/security/Auth'
import {
  CreateSalesRepUserInfoCognitoResponse,
  GenerateV3TokenResponse,
  UserAccessDetails,
} from '../api/user/interfaces'
import { StoreInstances } from '../store/StoreInstancesContainer'
import { BaseServiceProvider } from './BaseServiceProvider'
import { KeyValuePair } from 'interfaces'

class UserInfoServiceProvider extends BaseServiceProvider {
  constructor() {
    super(import.meta.env.VITE_API_BASE_URL, 'userinfo', '1.0', '')
  }

  acceptTermsAndConditions = async (): Promise<number> => {
    try {
      const response = await this.put('accept-eula')
      if (response.status === 200) {
        StoreInstances.userStore.setUserPreferences({
          ...StoreInstances.userStore.preferences,
          EULA_accepted: 'true',
        })
      }
      return response.status
    } catch (_e) {
      StoreInstances.uiStore.displayErrorNotification(
        'failedToAcceptTermsAndConditions'
      )
      return null
    }
  }

  getUserAccess = async (userId: string): Promise<UserAccessDetails> => {
    // Using axios as this API doesn't require authentication.
    const { data } = await this.get<UserAccessDetails>('useraccess', {
      params: { userId },
    })
    return data
  }

  updateMiscPreferences = (
    data: Array<KeyValuePair<string>>
  ): Promise<void> => {
    if (!data || data.length === 0) {
      return Promise.resolve()
    }
    return this.put('updateMiscPreferences', data, {
      params: { userId: Auth.getUserId() },
    })
  }

  createSalesRepUserInfoCognito = async (
    userId: string,
    orgId: number
  ): Promise<string> => {
    try {
      const { data } = await this.post<CreateSalesRepUserInfoCognitoResponse>(
        'createSalesRepUserInfoCognito',
        { userId: Number(userId), orgId }
      )

      if (data?.statusCode === 200) {
        return data?.key || ''
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }

    return ''
  }

  generateV3Token = async (key: string): Promise<string> => {
    try {
      const { data } = await this.get<GenerateV3TokenResponse>(
        'generateV3Token',
        { params: { userId: key } }
      )

      if (data?.status === 'success') {
        return data?.token || ''
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }

    return ''
  }
}

export default new UserInfoServiceProvider()
